import React from 'react';
import { Global, css } from '@emotion/react';
import { palette } from './palette';
import { fontFamilies } from './typography';

type Scale = Record<number, string>;

const scaleToVars = (name: string, scale: Scale): string =>
    Object.entries(scale)
        .map(([step, hex]) => `--${name}-${step}: ${hex};`)
        .join('\n');

const rootVars = css`
    :root {
        ${scaleToVars('burgundy', palette.burgundy)}
        ${scaleToVars('sand', palette.sand)}
        ${scaleToVars('orange', palette.orange)}
        ${scaleToVars('blue', palette.blue)}
        ${scaleToVars('success', palette.success)}
        --white: ${palette.white};
        --grey: ${palette.grey};
        --font-sans: ${fontFamilies.sans};
        --font-expanded: ${fontFamilies.expanded};
    }
`;

const GlobalTokens: React.FC = () => <Global styles={rootVars} />;

export default GlobalTokens;
